import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { LabelBadge } from "@/components/LabelBadge";
import { Search as SearchIcon } from "lucide-react";

export default function SearchPage() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [results, setResults] = useState([]);

  useEffect(() => {
    const query = params.get("q") || "";
    setQ(query);
    if (!query.trim()) { setResults([]); return; }
    api.get("/search", { params: { q: query } }).then((r) => setResults(r.data)).catch(() => setResults([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const submit = (e) => { e.preventDefault(); setParams(q ? { q } : {}); };

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
      <h1 className="font-serif-arc text-3xl font-black tracking-tight sm:text-4xl">Search the Archives</h1>
      <form onSubmit={submit} className="mt-6 flex items-center gap-2 rounded-md border px-3 py-2" style={{ backgroundColor: "var(--arc-card)" }}>
        <SearchIcon size={18} className="opacity-60" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search the archives…" className="border-0 shadow-none focus-visible:ring-0" data-testid="search-page-input" />
      </form>

      <div className="mt-6 space-y-3">
        {params.get("q") && results.length === 0 && <p className="text-sm" style={{ color: "var(--arc-text-2)" }}>No results for "{params.get("q")}".</p>}
        {results.map((r) => (
          <Link key={r.slug} to={`/article/${r.slug}`} data-testid={`search-page-result-${r.slug}`} className="block rounded-md border p-5 shadow-sm transition-shadow hover:shadow-md" style={{ backgroundColor: "var(--arc-card)" }}>
            <div className="flex items-center justify-between gap-2">
              <span className={`font-serif-arc text-lg font-bold ${r.encyclopedia === "ghoulax" ? "ghoulax-accent" : "zyfley-accent"}`}>{r.title}</span>
              {r.badge && <LabelBadge label={r.badge} />}
            </div>
            <p className="mt-1 text-sm" style={{ color: "var(--arc-text-2)" }}>{r.description}</p>
            <div className="mt-2 flex flex-wrap gap-x-4 text-xs" style={{ color: "var(--arc-text-2)" }}>
              <span>{r.encyclopedia === "ghoulax" ? "Ghoulax Archives" : "Zyfley Encyclopedia"}</span>
              {r.updated_at && <span>Last updated: {new Date(r.updated_at).toLocaleDateString()}</span>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
